/* eslint-disable */
/**
 * StatusBadge — Pill i 6 integrations-statusfarver + 3 agent-statusfarver
 *
 * Integration-sprog (til datakilder som Dinero, Facebook, Google):
 *   status  'LIVE' | 'KONFIGURERET' | 'IKKE FORBUNDET' | 'OPMÆRKSOMHED' | 'FEJL' | 'AI'
 *
 * Agent-sprog (til agenter og afdelinger — brug disse til AgenterPanel + AfdelingerPanel):
 *   status  'AKTIV' | 'STANDBY' | 'FEJL_AGENT'
 *
 * Fælles props:
 *   tekst   string — override badge-tekst (default: viser status-værdien)
 *   lille   bool   — reduceret størrelse
 *   puls    bool   — pulserende animation (bruges til FEJL / FEJL_AGENT)
 *   style   obj
 */

import React from 'react';
import { BADGE_FV, RADIUS } from './tokens';

export default function StatusBadge({ status = 'IKKE FORBUNDET', tekst, lille = false, puls = false, style = {} }) {
  const bf = BADGE_FV[status] || BADGE_FV['IKKE FORBUNDET'];
  const label = tekst || status;

  return (
    <span
      style={{
        display:      'inline-flex',
        alignItems:   'center',
        gap:          5,
        fontSize:     lille ? 9 : 10,
        fontWeight:   700,
        padding:      lille ? '1px 6px' : '3px 9px',
        borderRadius: RADIUS.pill,
        background:   bf.bg,
        border:       `1px solid ${bf.kant}`,
        color:        bf.txt,
        textTransform: 'uppercase',
        letterSpacing: 0.7,
        whiteSpace:   'nowrap',
        ...style,
      }}
    >
      {/* Puls-dot til OPMÆRKSOMHED + FEJL */}
      {puls && (
        <span style={{
          width:        6,
          height:       6,
          borderRadius: '50%',
          background:   bf.txt,
          display:      'inline-block',
          animation:    'puls-ring 1.6s ease-in-out infinite',
          flexShrink:   0,
        }} />
      )}
      {label}
    </span>
  );
}
